import React, { useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectListData } from '../../../actions/project';
import { closeModalAction } from '../../../actions/modal';
import { useForm } from 'react-hook-form';
import Form from '../../../common/Form';
import Select from '../../../common/Form/Select';
import { debounce } from '../../../utils/common';
import { getLinkedProjects, linkProject } from '../../../actions/teams';
import Project from '../../../components/Inputs/Project';

const formName = 'linkProjectsForm';

export default function LinkProjects({ team }) {
    const dispatch = useDispatch();
    const isProjectListLoading = useSelector((state) => state.loading.isProjectListLoading);
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const projectDropdownListData = useSelector((state) => state.project.projectDropdownListData);
    const linkedProjects = useSelector((state) => state.teams.linkedProjects);

    const getProjectList = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getProjectListData({ limit, page, query, dropdown: true, org_id }));
    };

    useEffect(() => {
        if (team.org_id) {
            getProjectList({ org_id: team.org_id });
        }
        dispatch(getLinkedProjects({ teamId: team.id }));
    }, [dispatch, team.org_id]);


    const defaultValues = {
        projects: '',
    };

    const submit = (form) => {
        const project_ids = form.projects.map((project) => project.value);
        dispatch(linkProject({ teamId: team.id, project_ids, formName }));
    };

    const methods = useForm({ defaultValues, mode: 'all' });


    const memoizedDropdownData = useMemo(() => {
        if (projectDropdownListData.length > 0) {
            if (linkedProjects && linkedProjects.length > 0) {
                const linkedProjectIds = linkedProjects.map((project) => project.id);
                return projectDropdownListData.filter((project) => !linkedProjectIds.includes(project.value));
            }
            return projectDropdownListData;
        }
        return projectDropdownListData;
    }, [linkedProjects, projectDropdownListData]);

    return (
        <Form
            methods={methods}
            onSubmit={submit}
            submitButtonText={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <div className='px-3 flex justify-between'>
                <Project name='projects' label='Project' required className='w-full' isMulti />
            </div >
        </Form >
    );
}
